import {Alert, Loading} from "fearless-common-ui";
import useGet from "../../../components/hooks/useGet";
import {backendEndpoints} from "../../../libs/backendEndpoints";
import {User, Slug, dateAsTimeString} from "fearless-common";

// TODO import from fearless-common
export interface UserNotificationModel {
  id: string; // UUID
  type: 'custom-html-message' | 'mentioned' | 'added-as-educator-to-course';
  text: string;
  created_by?: User | null;
  created_at: string;
  unread: boolean;
  modal_content?: string;
  navigateable?: {
    slug: Slug;
    id: number;
    group_id?: number;
  }
}

/**
 * Component that lists the notifications of a specific user
 * in the admin environment.
 */
export default function AdminUserNotifications({ userId }: {
  userId: User['id']
}) {
  const { data, isLoading, error } = useGet<UserNotificationModel[]>({
    endpoint: backendEndpoints.getAdminNotificationsForDisplay,
    params: {
      user_id: userId
    }
  });

  return (
    <>
      {isLoading && <Loading />}
      {error && <Alert>Error</Alert>}
      {Array.isArray(data) ? (
        data.map((notification) => (
          <li className="d-flex align-items-center border-bottom py-2" key={notification.id}>
            <div className="pe-2 text-xs">
              <small className="d-block text-start neutral-600">{dateAsTimeString(notification.created_at)}</small>
              <small
                className={notification.unread ? 'fw-bold' : 'fw-normal'}
                style={{ lineHeight: 1.2, display: 'block' }}
                dangerouslySetInnerHTML={{ __html: notification.text }}
              />
            </div>
          </li>
        ))
      ) : null}
    </>
  );
}
